import { isTable } from '../../../common/elements/utils/elementTypeUtils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { finishEditingCurrentElement } from '../../element/selection/selectionActions';
import { popupsOpenSelector } from '../../components/popupPanel/popupOpenSelector';
import { POPUPS_BY_SECTION, PopupSections } from '../../components/popupPanel/popupConstants';
import useUpdatedRef from '../react/useUpdatedRef';
import { getIsAnySheetOpen } from '../../mobile/structural/sheet/sheetSelectors';
import { getCurrentlyEditingElement } from '../../element/selection/currentlyEditingSelector';
import { getIsModalOpen } from '../../components/modal/activeModalSelector';

export default () => {
    const dispatch = useDispatch();
    const dispatchFinishEditing = () => dispatch(finishEditingCurrentElement());

    const toolbarPopupOpen = useSelector(popupsOpenSelector(POPUPS_BY_SECTION[PopupSections.TOOLBAR]));
    const toolbarPopupOpenRef = useUpdatedRef(toolbarPopupOpen);

    const isAnySheetOpen = useSelector(getIsAnySheetOpen);
    const isAnySheetOpenRef = useUpdatedRef(isAnySheetOpen);

    const isAnyModalOpen = useSelector(getIsModalOpen);
    const isAnyModalOpenRef = useUpdatedRef(isAnyModalOpen);

    const currentlyEditingElement = useSelector(getCurrentlyEditingElement);
    const currentlyEditingElementRef = useUpdatedRef(currentlyEditingElement);

    /**
     * Determine whether to dispatchFinishEditing when the keyboard hides.
     * e.g. Should dispatchFinishEditing when user tap the done button on the iOS keyboard,
     *      so that the toolbar change from editing mode to selection mode
     */
    const shouldDispatchFinishEditingOnKeyboardHide = () => {
        // When keyboard hides and a sheet is open, we don't want to finish editing as the user is likely
        // still interacting with the sheet
        if (isAnySheetOpenRef.current) return false;

        // When keyboard hides and a modal is open, we don't want to finish editing as the user is likely
        // still interacting with the modal (e.g. document modal)
        if (isAnyModalOpenRef.current) return false;

        // When keyboard hides and the currently editing element is a table, we don't want to finish editing as
        // the keyboard hiding might be due to interactions with the table toolbar popup
        // TODO: When we enable table editing on mobile, we would need to update this check
        if (isTable(currentlyEditingElementRef.current) && toolbarPopupOpenRef.current) return false;

        return true;
    };

    useEffect(() => {
        window.addEventListener('keyboardWillHide', () => {
            if (!shouldDispatchFinishEditingOnKeyboardHide()) return;

            dispatchFinishEditing();
        });
    });
};
